// @ts-nocheck

import React from 'react';
import styled, { css } from 'styled-components';

import BoomBasketSwitchContainer from '../../modules/boom/components/BoomBasketSwitch/BoomBasketSwitchContainer';
import GRBasketSwitchContainer from '../../modules/gift-race/components/GRBasketSwitch/GRBasketSwitchContainer';
import KLBasketSwitchContainer from '../../modules/koh-lanta/containers/KLBasketSwitchContainer';
import MissionBasketSwitchContainer from '../../modules/missions/components/MissionBasketSwitch/MissionBasketSwitchContainer';
import MPBasketSwitchContainer from '../../modules/monopoly/containers/MPBasketSwitchContainer';
import theme from '../../styled-components/dark';
import { BasketModes } from '../../types/basket';
import type { BasketMode } from '../../types/basket';
import BasketCtasContainer from '../BasketCtas/BasketCtasContainer';
import BasketFreebetsSwitchContainer from '../BasketFreebetsSwitch/BasketFreebetsSwitchContainer';
import BasketKeyboardContainer from '../BasketKeyboard/BasketKeyboardContainer';
import BasketSummaryContainer from '../BasketSummary/BasketSummaryContainer';
import BasketSystems from '../BasketSystems';

const Fixed = styled.div`
  background-color: ${theme.BasketFooter.backgroundColor};
  padding-bottom: constant(safe-area-inset-bottom);
  padding-bottom: env(safe-area-inset-bottom);

  ${({ $isEmpty }) =>
    !$isEmpty
      ? css`
          border-top: solid 1px ${theme.BasketFooter.borderTopColor};
        `
      : null}
`;

const switchesSharedStyle = css`
  padding: 0.4em 0.6em;
`;

const StyledBasketFreebetsSwitchContainer = styled(BasketFreebetsSwitchContainer)`
  ${switchesSharedStyle}
`;

const StyledGRBasketSwitchContainer = styled(GRBasketSwitchContainer)`
  ${switchesSharedStyle}
`;

const StyledKLBasketSwitchContainer = styled(KLBasketSwitchContainer)`
  ${switchesSharedStyle}
`;

const StyledMissionBasketSwitchContainer = styled(MissionBasketSwitchContainer)`
  ${switchesSharedStyle}
`;

const StyledMPBasketSwitchContainer = styled(MPBasketSwitchContainer)`
  ${switchesSharedStyle}
`;

const StyledBoomBasketSwitchContainer = styled(BoomBasketSwitchContainer)`
  ${switchesSharedStyle}
`;

type BasketFooterProps = {
  isEmpty: boolean;
  isLoading: boolean;
  isCashout: boolean;
  showResume: boolean;
  isMobile: boolean;
  mode: BasketMode;
  isKeyboardVisible: boolean;
  closeKeyboard: (...params: unknown) => unknown;
};

const BasketFooter = ({
  isEmpty,
  isLoading,
  isCashout,
  showResume,
  isMobile,
  mode,
  isKeyboardVisible = false,
  closeKeyboard = () => {},
}: BasketFooterProps) => {
  return !isLoading ? (
    <Fixed className={isMobile} $isEmpty={isEmpty}>
      {!isEmpty ? (
        <>
          <div onClick={closeKeyboard}>
            {mode === BasketModes.SYSTEM ? <BasketSystems readOnly={showResume} shouldOpenModal={isMobile} /> : null}
            <StyledGRBasketSwitchContainer />
            <StyledKLBasketSwitchContainer />
            <StyledMPBasketSwitchContainer />
            <StyledBoomBasketSwitchContainer />
            <StyledMissionBasketSwitchContainer isFromBasketFooter />
            {!isCashout ? <StyledBasketFreebetsSwitchContainer /> : null}
          </div>
          <BasketSummaryContainer readOnly={showResume} />
          {isKeyboardVisible ? <BasketKeyboardContainer /> : null}
        </>
      ) : null}
      <div onClick={closeKeyboard}>
        <BasketCtasContainer />
      </div>
    </Fixed>
  ) : null;
};

export default BasketFooter;
